<ln-ln-pages-armor [showFooter]="false" xmlns="http://www.w3.org/1999/html">
  <section body class="bg-blanco">
    <div class="hidden border-t-[2.5px] border-t-beige border-opacity-60 bg-beige bg-opacity-20 sm:block"></div>
    <div class="max-w-[1440px] mx-auto flex flex-col justify-center">
    <!--    hero-->
    <section class="mx-[15px] pt-[28px] sm:mx-[67px] sm:pt-[0px]">
      <ln-contact-page-header></ln-contact-page-header>
    </section>
    <!--body-->
    <section class="mx-[15px] sm:mx-[67px] pb-[30px]">
      <div class="flex flex-col sm:flex-row mt-[30px]  space-y-[15px] sm:mt-[22px]  sm:space-x-[130px]">
<!--        formulario-->
        <section>
          <ln-contact-page-form-of-contact (showUnSuccessfulModal)="presentUnSuccessfulModal()"></ln-contact-page-form-of-contact>
        </section>
        <div id="error-msg">
        @if(showUnSuccessfulModal()) {
          @if (showUnSuccessfulOrderCardBottom()) {
            <div  class="flex-col h-full justify-end block sm:hidden mb-[20px]">
              <ln-unsuccessful-order-response-card
                [present]="showUnSuccessfulOrderCardBottom"
                [text]="'messages.unSuccessfulOrder' | transloco"></ln-unsuccessful-order-response-card>
            </div>
          }
        }
        </div>
        <div class="flex flex-col space-y-[21px] sm:space-y-[28px] items-center">
          <div class="h-[42px] w-[344px] justify-center sm:h-[56px] sm:w-[456px]">
            <span class="font-['Roboto'] text-lg font-normal text-cafe sm:text-2xl"
              >{{'labels.youCanContactUs' | transloco}}
            </span>
            <span class="font-['Roboto'] text-lg font-medium text-cafe sm:text-2xl">{{'labels.socialNetworks' | transloco}}</span
            ><span class="font-['Roboto'] text-lg font-normal text-cafe sm:text-2xl"> {{'labels.orVia' | transloco}} </span
            ><span class="font-['Roboto'] text-lg font-medium text-cafe sm:text-2xl">{{'buttons.whatsApp' | transloco}}</span
            ><span class="font-['Roboto'] text-lg font-normal text-cafe sm:text-2xl">.</span>
          </div>
          <div class="flex flex-row justify-center space-x-[15px]">
            <ln-left-icon-button
              [class]="
                'flex h-[56px] w-[165px] rounded-3xl border border-gris items-center justify-center space-x-[10px] transition-transform duration-300 hover:scale-110'
              "
              *transloco="let t"
              (click)="navigateToInstagram(t('messages.lunaNuevaPortalContact'))"
              >
              <ln-instagram-svg-icon icon class="h-6 w-6" fillColor="#B79086"></ln-instagram-svg-icon>
              <div label class="justify-center text-verde text-base font-normal font-['Roboto']">{{'buttons.instagram' | transloco}}</div>
            </ln-left-icon-button>
            <ln-left-icon-button
              [class]="
                'flex h-[56px] w-[165px] rounded-3xl border border-gris items-center justify-center space-x-[10px] transition-transform duration-300 hover:scale-110'
              "
              *transloco="let t"
              (click)="navigateToWhatsapp(t('messages.lunaNuevaPortalContact'))">
              <ln-whatsapp-svg-icon icon class="h-6 w-6" fillColor="#577778"></ln-whatsapp-svg-icon>
              <div label class="justify-center text-verde text-base font-normal font-['Roboto']">{{'buttons.whatsApp' | transloco}}</div>
            </ln-left-icon-button>
          </div>
          @if(showUnSuccessfulModal()) {
            @if (showUnSuccessfulOrderCardBottom()) {
<!--              <div class="hidden sm:block">-->
                <div class="flex flex-col w-[456px] sticky bottom-0">
                  <ln-unsuccessful-order-response-card
                    class="hidden sm:block"
                    [present]="showUnSuccessfulOrderCardBottom"
                    [text]="'messages.unSuccessfulOrder' | transloco"></ln-unsuccessful-order-response-card>
                </div>
            }
          }
        </div>
      </div>
    </section>
    </div>
  </section>

</ln-ln-pages-armor>
